<template>
    <div class="pdf-item p-0 m-0" v-if="transaction!==undefined">
    <div class="text-center col-12" style="background: #fff" :style="{borderTop:'1px solid'+ getColor()}">
        <div class="row">
            <div class="img-header-gate col-2 text-left pt-0">
                <img v-if="transaction._store.logo_url && transaction._store.logo_url.length"  :src="transaction._store.logo_url" alt="logo intram" class="card-image">
                <span v-else class="texteLogo" :style="{color: 'black'}">{{transaction._store.name.charAt(0).toUpperCase()}}</span>
            </div>
            <div class="col-4 text-left pt-4">
                            <span class="text-uppercase shop_name">
                               {{transaction._store.name}}
                            </span>
                <br>
                <span>{{transaction._store.phone}}</span>
                <br>
                <span>{{transaction.marchand._email}}</span> <br>
                <span>{{transaction.marchand._base_url_site_web}}</span>
            </div>
            <div class="offset-1 col-5">
                <div class="row">
                    <h6 class="col-4">Customer : </h6>
                    <div class="col-8 text-left pt-0">
                        <span>{{transaction.customer!==undefined ? transaction.customer._first_name:''}} {{transaction.customer!==undefined ? transaction.customer._last_name : ''}}</span>
                        <br>
                        <span>{{transaction.customer!==undefined ? transaction.customer._phone :''}}</span>
                        <br>
                        <span>{{transaction.customer!==undefined ? transaction._country_code :''}}</span>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-left col-12 mt-4" style="background: #fff">
            <h4>TRANSACTION</h4>
            <table class="table   table-hover table-no-bordered" v-if="transaction.invoice.items.length>0">
                <tbody>
                <tr><td>SOURCE</td>
                    <td>NUMERO SOURCE</td>
                    <td class="text-uppercase">FRAIS APPLIQUés</td>
                    <td>DEVISE</td>
                    <td>PAYS</td>
                </tr>
                <tr>
                    <td><span style="color: #1a1e31">MTN/MOOV</span></td>
                    <td><span style="color: #1a1e31">{{transaction._num_source}}</span></td>
                    <td><span style="color: #1a1e31">{{transaction._fees}}</span></td>
                    <td><span style="color: #1a1e31">{{transaction.invoice.currency}}</span></td>
                    <td><country-flag :country=" transaction._country_code" style="" size='normal'/></td>
                </tr>
                </tbody>
            </table>
        <div>
            Facture générer le :
            <span>{{today()}}</span>
            <br>
            Site web du marchand :  <span>{{transaction.marchand._base_url_site_web}}</span>
        </div>

    </div>
    <div class="col-12 text-left" :style="{color: '#1e3551'}">
        <div class="row">
            <div class="col-12 col-lg-12 pb-0 detail_paiement">
                <h4>PRODUITS</h4>
                <table class="table   table-hover table-no-bordered" v-if="transaction.invoice.items.length>0">
                    <thead><th>produit</th><th>quantité</th><th>pu</th><th>total</th></thead>
                    <tbody>
                    <tr v-for="item in transaction.invoice.items" :key="item._id"><td>{{item.name}}</td><td>{{item.quantity}}</td><td>{{item.price}}</td><td>{{item.total_amount}} {{transaction.invoice.currency}}</td></tr>
                    </tbody>
                </table>
            </div>
            <div class="offset-lg-6 col-lg-6 offset-md-6 col-md-6  col-12  detail_paiement"  style="margin-top: 20px;margin-bottom: 20px;">
                <h4>TAXE-REDUCTION-TOTAL</h4>
                <table class="table  table-hover table-no-bordered" v-if="transaction.invoice.items.length>0">
                    <tbody>
                    <tr><td colspan="3">Total</td><td>{{getInvoiceTotal(transaction.invoice.items)+' '+transaction.invoice.currency}}</td></tr>
                    <tr><td colspan="3">Taxe</td><td>+25%</td></tr>
                    <tr><td colspan="3">Frais de transaction</td><td>{{transaction._fees}}</td></tr>
                    <tr style="background: #f8f8f8"><td colspan="3">Total à payer </td><td>{{transaction._amount+' '+transaction.invoice.currency}} </td></tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
    import helpers from "../../mixins/helpers";
    export default {
        name: "invoiceFirst",
        props:['transaction'],
        mixins:[helpers(this)],
        data(){
          return {
              load:0,
              htmlToPdfOptions: {
                  margin: 0,
                  image: {
                      type: 'png',
                      quality: 0.98
                  },
                  enableLinks: true,
              }
          }
        },
        methods:{
            getInvoiceTotal(items){
                let sum  =0;
                items.forEach ((item)=>{
                    let amnt = (item.total_amount)?parseInt(item.total_amount):0;
                    sum+=amnt;
                });
                return sum;
            },
            today(){
                let today = new Date(),
                    dd = String(today.getDate()).padStart(2, '0'),
                    mm = String(today.getMonth() + 1).padStart(2, '0'), //January is 0!
                    yyyy = today.getFullYear();
                return  mm + '/' + dd + '/' + yyyy;

            },
            onProgress(){
            },
            hasStartedGeneration(){
            },
            hasGenerated(){
            }
        },beforeRouteEnter() {
             location.reload();
        }
    }
</script>


<style scoped>
    .img-header-gate img{
        width: 100%;
    }
    .text-details{
        font-size: 12pt;
    }
    .detail_paiement{
        padding-top: 15px;
        background: #fff;
    }
   .pdf-content{
    margin: 0px!important;
    padding: 0px!important;
}
    .itemsTilte{
        color: #fff;
        padding: 7px 12px;
        cursor: pointer;
        margin-bottom: 0;
    }

    @media (max-width: 991px) {

        .texteLogo{
            font-size: 20pt;
            display: inline;
        }

        .text-details{
            font-size: 8pt !important;
            margin-top: -10px;
        }

        .itemsTilte{
            padding: 5px 12px;
            font-size: 10pt;
        }

        .img-header-gate_mini img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 10px solid #1e3551;
        }

    }

    .footer-gate-payment img{
        width: 50px;
    }
    .top-second-gate-header{
        color: #fff;
        padding: 0 10px;
    }
    .top-second-gate-header .htitle{
        font-size: 7pt;
    }


    .portail_text{
        font-size: 25pt;
        font-weight: 500;
        padding: 10px;
    }
    .shop_name{
        font-weight: 500;
        font-size: 10pt;
    }
    .paiement_price_box{
    }
    .paiement_price_box .htitle{
        font-size: 8pt;
        font-weight: 500;
    }
    .paiement_price_box .price{
        font-size: 20pt;
        font-weight: bold;
    }
    .payment-mean-img{
        height: 10%;
    }

    @keyframes flickerAnimation {
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-o-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-moz-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }
    @-webkit-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }
.card-image{
    border-radius: 10px;
    padding: 15px;
    border: 1px solid #dcdcdc;
}
</style>